import { useEffect, useState } from 'react';

const useSelection = () => {
  const [selected, setSelected] = useState([]);
  const [isSelectAllIndeterminate, setIsSelectAllIndeterminate] = useState(false);

  useEffect(() => {
    if (selected.length === 0) {
      setIsSelectAllIndeterminate(false);
    }
  }, [selected]);

  const clearSelected = () => {
    setSelected([]);
    setIsSelectAllIndeterminate(false);
  };

  const handleSelectAllOnPage = (list) => {
    if (selected.length === list.length || isSelectAllIndeterminate) {
      clearSelected();
    } else {
      setSelected([...new Set(list.map((item) => item.id))]);
      setIsSelectAllIndeterminate(false);
    }
  };

  const handleSelectEntireList = (idList) => setSelected([...idList]);

  const handleSelect = (id) => {
    setSelected((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((itemId) => itemId !== id);
      }
      return [...prevSelected, id];
    });
    setIsSelectAllIndeterminate(true);
  };

  const isSelected = (id) => selected.includes(id);

  const isAllSelected = (list) => selected.length === list.length && list.length;

  const isIndeterminate = () => isSelectAllIndeterminate;

  const getSelectedObjectsFromList = (list) => list.filter((item) => isSelected(item.id));

  return {
    selected,
    handleSelectAllOnPage,
    handleSelect,
    isSelected,
    isAllSelected,
    isIndeterminate,
    clearSelected,
    getSelectedObjectsFromList,
    handleSelectEntireList,
  };
};

export default useSelection;
